/*******************************************************************************
 * Copyright     : Copyright (c)  2019 Honeywell Inc. All rights reserved.
 *                 This work contains trade secrets and confidential materials
 *                 of Honeywell Inc., and its use or disclosure in whole or in
 *                 part without express written permission of Honeywell Inc.
 *                 is prohibited.
 *
 * Name          :   products-alerts-reducer.ts
 *
 * Project Title :  Checkout
 *
 * Description	 :
 *
 *
 * Company       : Honeywell Technology Solutions , Hyderabad
 *
 * @Author       : Deepthi Bachu (E844276)
 *
 * @Date	     : Nov 18, 2019
 *
 * @Version      : Version 1.0
 *
 * By            : Suresh Jaladi - E807958
 * On            : Dec 06, 2019
 * Description   : ASDS-1811
 *
 * By            	: Snigdha
 * On            	: Feb 10, 2019
 * Description      : ASDS-2268
 *
 * By            : H224423
 * On            : Apr 03 2020
 * Description   : ASDS-2190 - API error handling changes
 *
 ******************************************************************************/

import Reducer from './reducer';
import { AsdsReduxAction } from '../../../../types';
import { createReducer } from '../utils/redux-util';
import ActionConstants from '../action-constants';

class ProductAlertReducer extends Reducer {
    static setAlertModel(state, action: AsdsReduxAction) { // show/hide success/failure message on product added to cart.
        return {
            payload: {
                ...state.payload,
                showAlertMsg: action.payload.showAlertMsg,
                isAddToCartSuccess: action.payload.isAddToCartSuccess
            }
        };
    }

    static showProductInCompatableAlert(state, action: AsdsReduxAction) {
        return {
            payload: {
                ...state.payload,
                inCompatibleProducts: action.payload.inCompatibleProducts
            }
        };
    }

    static closeProductInCompatableAlert(state) {
        return {
            payload: {
                ...state.payload,
                inCompatibleProducts: false
            }
        };
    }

    // static showInvalidProductToAddToCart(state, action: AsdsReduxAction) {
    //     return {
    //         payload: {
    //             ...state.payload,
    //             invalidProducts: action.payload.invalidProducts,
    //             productId: action.payload.productId
    //         }
    //     };
    // }

    static closeInvalidProductToAddToCart(state) {
        return {
            payload: {
                ...state.payload,
                invalidProducts: false,
                productId:""
            }
        };
    }

    static addProductToCartLoader(state: any, action: AsdsReduxAction) {
        return {
            payload: {
                ...state.payload,
                addProductToCartInProgress: action.payload.addProductToCartInProgress,
            }
        };
    }
    static setGenricFields(state: any, action: AsdsReduxAction) {
        return {
            payload: {
                ...state.payload,
                inCompatibleProducts: action.payload.inCompatibleProducts,
                isApptusProductsAddedToCart: action.payload.isApptusProductsAddedToCart,
                isBMSProductsAddedToCart: action.payload.isBMSProductsAddedToCart,
            }
        };
    }

    static updateLastAddedProdToCart(state, action: AsdsReduxAction) {
        return {
            payload: {
                ...state.payload,
                lastProdAddedToCart: action.payload.lastProdAddedToCart,
            }
        };
    }
}

const productAlertHandler = {
    [ActionConstants.SET_ALERT_MODEL]: ProductAlertReducer.setAlertModel,
    [ActionConstants.SHOW_INCOMPATIBLE_TO_ADD_TO_CART]: ProductAlertReducer.showProductInCompatableAlert,
    [ActionConstants.CLOSE_PRODUCT_ALERT_MODAL]: ProductAlertReducer.closeProductInCompatableAlert,
    [ActionConstants.ADD_PRODUCT_TO_CART_LOADER]: ProductAlertReducer.addProductToCartLoader,
    [ActionConstants.SET_GENERIC_FIELDS]: ProductAlertReducer.setGenricFields,
    [ActionConstants.UPDATE_LAST_PROD_CART]: ProductAlertReducer.updateLastAddedProdToCart,
    //[ActionConstants.SHOW_INVALID_PRODUCT_TO_ADD_TO_CART]: ProductAlertReducer.showInvalidProductToAddToCart,
    [ActionConstants.CLOSE_INVALID_PRODUCT_TO_ADD_TO_CART]: ProductAlertReducer.closeInvalidProductToAddToCart,
};

const initialState = {
    payload: {
        isApptusProductsAddedToCart: false, // tells Apptues products are present in cart
        isBMSProductsAddedToCart: false, // this field tells BMS products are present in cart,
        inCompatibleProducts: false, // tells selected product is in compatible to add to cart, based on this flag we
        showAlertMsg: false, // using this show/hide product Successfully added to cart Alert model.
        addProductToCartInProgress: false,
        lastProdAddedToCart: '',
        invalidProducts: false,
        productId:'',
        isAddToCartSuccess: false // tells whether add to cart event is success
    }
};

export const productAlertData = createReducer(initialState, productAlertHandler);
